"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowLeft = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowLeft = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M22 11.498v1a.5.5 0 01-.5.5H5.33l4.45 4.44a.5.5 0 010 .71l-.71.7a.5.5 0 01-.71 0l-6.14-6.13a.75.75 0 01-.22-.53v-.38a.77.77 0 01.22-.53l6.14-6.13a.5.5 0 01.71 0l.71.71a.49.49 0 010 .7l-4.45 4.44H21.5a.5.5 0 01.5.5z" })); };
exports.ArrowLeft = ArrowLeft;
//# sourceMappingURL=arrow-left.js.map